module.exports = __webpack_public_path__ + "static/stories-hero-513d30052d89d91bc1a3bccd791455a4.png";